import { render } from "./student-base.vue?vue&type=template&id=5b7caa95"
import script from "./student-base.vue?vue&type=script&lang=js"
export * from "./student-base.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__